var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { omit } from 'lodash';
import PropTypes from 'prop-types';
import BaseWidget from '../BaseWidget';
import CountdownTimer from './CountdownTimer.js';
import CircleClasses from 'nucleus-core/less/cv/Countdown.Circle.structure.less';
import FlipClasses from 'nucleus-core/less/cv/Countdown.Flip.structure.less';
import { resolveTestId } from '@cvent/nucleus-test-automation';
var CountdownCircleStyle = {
    container: CircleClasses.container,
    countdown: CircleClasses.countdown,
    circle: CircleClasses
};
var CountdownFlipStyle = {
    container: FlipClasses.container,
    countdown: FlipClasses.countdown,
    flip: FlipClasses
};
/**
* Data wrapper for the CountdownTimer widget.
*/
var CountdownTimerWidget = /** @class */ (function (_super) {
    __extends(CountdownTimerWidget, _super);
    function CountdownTimerWidget() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CountdownTimerWidget.prototype.getStyleObject = function () {
        var counterBackground = this.getElementBackground('counter');
        if (this.props.config.type === 'flip') {
            counterBackground.borderRadius = 5;
        } // Removing hover styles from the `counter` element.
        // Because of the way the countdown component was built, hover styles
        // would only be applied to part of the circles on hover.
        return __assign(__assign({}, _super.prototype.getStyleObject.call(this)), { spacing: this.getElementSpacing('counter'), background: omit(counterBackground, 'hover'), digit: omit(this.getElementText('counter'), 'hover'), timer: omit(this.getElementInlineStyle('counter'), 'hover'), label: this.getElementInlineStyle('text') });
    };
    CountdownTimerWidget.prototype.render = function () {
        var _a = this.props, config = _a.config, translate = _a.translate;
        var inlineStyles = this.getStyleObject();
        var mergedStyles = {
            countdown: inlineStyles.container,
            circle: {
                counter: inlineStyles.spacing,
                circle: inlineStyles.background,
                digit: inlineStyles.digit,
                label: inlineStyles.label,
                border: inlineStyles.timer
            },
            flip: {
                counter: inlineStyles.spacing,
                top: inlineStyles.background,
                bottom: inlineStyles.background,
                flip: inlineStyles.background,
                digit: inlineStyles.digit,
                digitTop: inlineStyles.digit,
                label: inlineStyles.label
            }
        };
        var classes = config.type === 'circle' ? CountdownCircleStyle : CountdownFlipStyle;
        var endDate = new Date(config.date);
        return React.createElement(CountdownTimer, __assign({}, resolveTestId(this.props), { classes: classes, endDate: endDate, style: mergedStyles, type: config.type, daysLabel: translate('_dateLabels_days__resx'), showDays: config.showDays, hoursLabel: translate('_dateLabels_hours__resx'), showHours: config.showHours, minutesLabel: translate('_dateLabels_minutes__resx'), showMinutes: config.showMinutes, secondsLabel: translate('_dateLabels_seconds__resx'), showSeconds: config.showSeconds }));
    };
    CountdownTimerWidget.displayName = 'CountdownTimerWidget';
    CountdownTimerWidget.propTypes = {
        config: PropTypes.shape({}),
        // have different Component for flip and circle ???
        style: PropTypes.object,
        translate: PropTypes.func
    };
    return CountdownTimerWidget;
}(BaseWidget));
export default CountdownTimerWidget;
